import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { motion } from 'framer-motion';
import { Colors } from './style/theme';

export default function ComingSoonAPI() {
  return (
    <Container maxWidth="lg" component="section" sx={{ py: 6 }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6}>
          <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
            <Paper
              elevation={6}
              sx={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                p: 4,
                textAlign: 'center',
                backgroundColor: 'white',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: Colors.primary, mb: 1 }}>
                More APIs Coming Soon!
              </Typography>
              <Typography variant="body1" color="text.secondary">
                We’re continuously expanding our API suite to bring you more powerful and innovative 
                solutions. Stay connected to be the first to access our latest releases!
              </Typography>
            </Paper>
          </motion.div>
        </Grid>
      </Grid>
    </Container>
  );
}
